import React from "react";
import Routes from "./routes.jsx";

export default function App() {
  return <Routes />;
}
